import { Injectable } from '@angular/core';
import { PaginatedResponseInterface } from '@sport-activities/sdk';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { HasPaginationInterface } from '~/attendee/interfaces/has-pagination.interface';
import { ActivityService } from '~/core/services/activity/activity.service';
import { LoaderService } from '~/core/services/loader/loader.service';
import { TechnicalError } from '~/errors/class/error/technical-error';

export const SEARCH_LOADER_KEY = 'SEARCH';

@Injectable({
  providedIn: 'root',
})
export class PaginatedSearchService<M, F extends HasPaginationInterface> {
  public filters$: BehaviorSubject<F> = new BehaviorSubject(undefined);
  public model: new (value: Partial<M>) => M;
  public path: string;

  constructor(
    private readonly activityService: ActivityService,
    private readonly loaderService: LoaderService
  ) {}

  public search(filters: F): Observable<PaginatedResponseInterface<M>> {
    this.loaderService.start(SEARCH_LOADER_KEY);
    return this.activityService
      .getPaginatedResults<M, F>(this.path, filters, this.model)
      .pipe(
        catchError((error) => {
          this.loaderService.stop(SEARCH_LOADER_KEY);
          return throwError(
            () => new TechnicalError(`Search error : ${error}`)
          );
        }),
        tap(() => this.loaderService.stop(SEARCH_LOADER_KEY))
      );
  }
}
